<template>

    <div>
        
        <div class="custom-page-title">
            <h3>
                Kontakt os
            </h3>
        </div>

        <div class="container pd-50">
            
            <div class="row">

                <div class="col-lg-6 col-md-6 col-sm-12">
                    <h2>
                        Kontaktoplysninger
                    </h2>
                    <div class="contact-box">
                        <div style="border-radius:4px;overflow:hidden;">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9166.779387510944!2d10.245455193387553!3d54.94337173829329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b2d645cbd445dd%3A0xec8e91e72899cf26!2zUC4gUGVkZXJzZW4gJiBTw7huIEFwUywgU8O4Ynkgw4ZSw5g!5e0!3m2!1sda!2sdk!4v1533388978450" width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-lg-5 col-md-6 col-sm-12">
                                <b>P. Pedersen & Søn</b>
                                <br>
                                CVR: 60098018
                                <br>
                                494100 Vejgodstransport
                                <br>
                                P-nummer: 1002107587
                                <br>
                                Nørrebro 23
                                <br>
                                5985 Søby Ærø
                                <br><br>
                            </div>
                            <div class="col-lg-7 col-md-6 col-sm-12">
                                <b><i class="fas fa-phone"></i>&nbsp;&nbsp;Telefon</b>
                                <br>
                                <a href="tel:+4540436078" style="color:#8b0000;font-weight:bold;text-decoration:underline;font-size:24px;">
                                    40 43 60 78
                                </a>
                                <br><br>
                                <b><i class="fas fa-envelope"></i>&nbsp;&nbsp;E-mail</b>
                                <br>
                                <a href="mailto:karsten@p-pedersen.dk" style="color:#8b0000;font-weight:bold;text-decoration:underline;font-size:24px;">
                                    karsten@p-pedersen.dk
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12">
                    <h2>
                        Medarbejdere
                    </h2>
                    <div class="row">
                        
                        <employee 
                            name="Karsten Bil Pedersen"
                            position="Vognmand"
                        />

                        <employee 
                            name="Marianne Fly Pedersen"
                            position="Kontor"
                        />

                        <employee 
                            name="Birger D. Petersen"
                            position="Chauffør"
                        />

                        <employee 
                            name="Brian W. Weber"
                            position="Chauffør"
                        />

                        <employee 
                            name="Karsten L. Pedersen"
                            position="Chauffør"
                        />

                        <employee 
                            name="Lasse Z. Bil Pedersen"
                            position="Chauffør"
                        />

                        <employee 
                            name="Daniel Lillelund Larsen"
                            position="Chauffør"
                        />
                        
                        <employee 
                            name="Thomas Bjørn Lauritsen"
                            position="Chauffør"
                        />

                        <employee
                            name="Kenneth Larsen"
                            position="Chauffør"
                        />

                        <employee 
                            name="Uffe S. Kajhøj"
                            position="Chauffør"
                        />

                        <employee 
                            name="Jack Sørensen (afløser)"
                            position="Chauffør"
                        />

                        <employee 
                            name="Hans Gert Clausen"
                            position="Chauffør (afløser)"
                        />

                        <employee
                            name="Rasmus D. Pedersen"
                            position="Chaufør (afløser)"
                        />

                        <employee
                            name="Bjarne Jørgensen"
                            position="Chaufør (afløser)"
                        />

                    </div>
                </div>

            </div>

        </div>

    </div>

</template>

<style lang="scss" scoped>
h2 {
    margin-bottom: 30px;
}

.contact-box {
    
    iframe {
        height: 400px;
        width: 100%;
        border-radius: 4px;
    }
}
</style>

<script>
import Employee from '@/components/elements/employee'

export default {
    components: {
        Employee
    }
}
</script>




// WEBPACK FOOTER //
// contact.vue?8dbe20bc